import styled from 'styled-components'

import { Text } from '../text'
import type { TextProps } from '../text'

import { Color } from '../../theme/color'
import type { ColorKeys } from '../../theme/color'

interface LabelProps {
  size?: 'small' | 'medium' | 'large'
  shape?: 'default' | 'semiRound' | 'square'
  backgroundColor?: ColorKeys
  textColor?: TextProps['color']
  children?: any
}

export function Label(props: LabelProps) {
  const { size, textColor, children } = props

  const textSize = size === 'large' ? 18 : 14
  const textWeight = size === 'small' ? 400 : 600

  return (
    <StyledLabel {...props}>
      <Text size={textSize} weight={textWeight} color={textColor}>
        {children}
      </Text>
    </StyledLabel>
  )
}

export const StyledLabel = styled.div<LabelProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  ${({ size }) => {
    switch (size) {
      case 'small':
        return 'padding: 2px 4px;'
      case 'large':
        return 'padding: 6px 16px;'
      default:
        return `padding: 4px 8px;`
    }
  }}
  ${({ shape, size }) => {
    switch (shape) {
      case 'semiRound':
        if (size === 'large') return 'border-top-left-radius: 16px; border-bottom-right-radius: 16px;'
        return 'border-top-left-radius: 8px; border-bottom-right-radius: 8px;'
      case 'square':
        return ''
      default:
        if (size === 'small') return 'border-radius: 4px;'
        return 'border-radius: 8px;'
    }
  }}
  background-color: ${({ backgroundColor }) => (backgroundColor ? Color[backgroundColor] : Color.gray_2)};
`

export type { LabelProps }
